function stopPlayingVideosOnResize() {
  const embedWrappers = document.querySelectorAll(
    ".columns-component__video-embed-wrapper"
  );

  if (embedWrappers.length < 1) {
    return;
  }

  const resizeObserver = new ResizeObserver((entries) => {
    for (let entry of entries) {
      // Only stop the video if the wrapping element just got hidden...
      const el = entry.target;
      var style = window.getComputedStyle(el);
      if (style.display === "none") {
        const iframe = el.querySelector("iframe");
        if (iframe) {
          // This is to reload the iframe thus making it stop!
          const src = iframe.src;
          iframe.src = ``;
          iframe.src = src;
        }
      }
    }
  });

  embedWrappers.forEach((el) => resizeObserver.observe(el));
}

function closeOverlaysOnEscape() {
  const videoWrappers: NodeListOf<HTMLInputElement> = document.querySelectorAll(
    ".columns-component__video-checkbox"
  );
  if (videoWrappers.length < 1) {
    return;
  }
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      videoWrappers.forEach((el) => {
        el.checked = false;
      });
    }
  });
}

function addVideoSupport(elements: NodeListOf<HTMLElement>) {
  // Use this iframe to add to the label when you open a video...
  const iframe = document.createElement("iframe");
  iframe.setAttribute("width", "560");
  iframe.setAttribute("height", "315");
  iframe.setAttribute("frameborder", "0");
  iframe.setAttribute("allow", "autoplay");
  iframe.setAttribute("allowfullscreen", "");

  // Listen to changes to the input which toggles the embedded
  elements.forEach((project) => {
    const input: HTMLInputElement | null = project.querySelector(
      ".columns-component__video-checkbox"
    );
    const embedWrapper: HTMLLabelElement | null = project.querySelector(
      ".columns-component__video-embed-wrapper"
    );
    if (input && embedWrapper) {
      input.addEventListener("change", (e) => {
        embedWrapper.dataset.iframeSrc &&
          iframe.setAttribute("src", embedWrapper.dataset.iframeSrc);
        if (input.checked) {
          embedWrapper.appendChild(iframe);
        } else {
          embedWrapper.removeChild(iframe);
        }
      });
    }
  });
}

function addColumnsVideoSupport() {
  const columns: NodeListOf<HTMLElement> = document.querySelectorAll(
    ".columns-component__column"
  );
  addVideoSupport(columns);
}

export function columns() {
  stopPlayingVideosOnResize();
  closeOverlaysOnEscape();
  addColumnsVideoSupport();
}
